import React from 'react';
import 'whatwg-fetch';

export default class ModalConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.close = this.close.bind(this);
  }

  render() {
    if (this.props.isOpen === false) return null;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-sm'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>{this.props.modalText.title}</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <p>{this.props.modalText.message}</p>
            </div>
            <div className='modal-actions'>
              <button onClick={this.cancel} type='button' className='btn-link modal-action' data-dismiss='modal'>
                Annuler
              </button>
              <button onClick={this.submit} type='button' className='btn-link modal-action' data-dismiss='modal'>
                <strong>Ok</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  submit() {
    this.props.onSubmit();
    this.props.onClose();
  }

  cancel() {
    this.props.onCancel();
  }

  close() {
    this.props.onClose();
  }
}
